import { useEffect } from 'react';
import {} from '../components/tabs/index.js';
import {} from '../components/navigation-bar/index.js';
export function useArrowKeyTabs(containerRef, items, activeIndex, onKeyNavigate) {
    useEffect(() => {
        if (!onKeyNavigate)
            return;
        const container = containerRef.current;
        if (!container)
            return;
        const handleKeyDown = (e) => {
            if (!container.contains(document.activeElement))
                return;
            let newIndex = activeIndex;
            switch (e.key) {
                case 'ArrowRight':
                case 'ArrowLeft': {
                    e.preventDefault();
                    const dir = e.key === 'ArrowRight' ? 1 : -1;
                    const total = items.length;
                    for (let i = 0; i < total; i++) {
                        newIndex = (newIndex + dir + total) % total;
                        if (!items[newIndex]?.disabled) {
                            onKeyNavigate(newIndex);
                            break;
                        }
                    }
                    break;
                }
                case 'Home': {
                    e.preventDefault();
                    const firstEnabled = items.findIndex((item) => !item.disabled);
                    if (firstEnabled !== -1) {
                        onKeyNavigate(firstEnabled);
                    }
                    break;
                }
                case 'End': {
                    e.preventDefault();
                    const lastEnabled = [...items]
                        .reverse()
                        .findIndex((item) => !item.disabled);
                    if (lastEnabled !== -1) {
                        onKeyNavigate(items.length - 1 - lastEnabled);
                    }
                    break;
                }
                default:
                    break;
            }
        };
        container.addEventListener('keydown', handleKeyDown);
        return () => {
            container.removeEventListener('keydown', handleKeyDown);
        };
    }, [containerRef, items, activeIndex, onKeyNavigate]);
}
//# sourceMappingURL=use-arrow-navigation.js.map